// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as GAEventsConstants$PorterinFeature from "../../../core/constants/GAEventsConstants.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";
import * as CategorySelectorModuleScss from "../styles/CategorySelector.module.scss";

var styles = CategorySelectorModuleScss;

function ChangeCategoryCmp(Props) {
  var onChangeCategory = Props.onChangeCategory;
  var classNameOpt = Props.className;
  var currentCategory = Props.currentCategory;
  var category_name = Props.category_name;
  var change_label = Props.change_label;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  return React.createElement("div", {
              className: "" + styles["change-category-container"] + " " + className + "",
              onClick: (function (param) {
                  PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, GAEventsConstants$PorterinFeature.gaEstimateVerticalSwitchAction, undefined);
                  PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, GAEventsConstants$PorterinFeature.gaEstimateVerticalSwitchCategoryAction + currentCategory, undefined);
                })
            }, React.createElement("div", {
                  className: styles["current-category-text"]
                }, category_name), React.createElement("button", {
                  className: styles["change-button"],
                  onClick: (function (param) {
                      Curry._1(onChangeCategory, undefined);
                    })
                }, change_label));
}

var make = ChangeCategoryCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
